export default "__VITE_ASSET__BSvTL9rz__"